import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DEPARTMENTS_REPOSITORY } from '../domain/repositories/departments.repository';
import { DepartmentsRemoteDatasource } from './datasources/remote/departments.remote-datasource';
import { DepartmentMapper } from './mappers/department.mapper';
import { DepartmentsRepositoryImpl } from './repositories/departments.repository.impl';

export function provideDepartmentsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DepartmentsRemoteDatasource,
    DepartmentMapper,
    { provide: DEPARTMENTS_REPOSITORY, useClass: DepartmentsRepositoryImpl },
  ]);
}
